import { gql } from '@apollo/client'

export const SAVE_OBJECTIVES_BONUS_DISTRIBUTION = gql`
  mutation SaveTargetBonusAmountDistribution($inputs: [ObjectiveDistributedAmountInput!]!, $meetingId: HashedId!) {
    saveTargetBonusAmountDistribution(objectivesDistributedAmountInput: $inputs, meetingId: $meetingId)
  }
`
